import React from 'react';

import { getTranslateFunc } from '../../../../utils/stringUtil';
import IbButton from '../../../../components/common/IbButton';
import IbTypography from '../../../../components/common/IbTypography';
import IbConfirmModal from '../../../../components/common/IbConfirmModal';
import { FolderModel } from '../../../../../gamma-api';
import { isEmptyFolder } from '../utils';

interface IDeleteFolderProps {
  folder?: FolderModel;
  loading?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
}

const DeleteFolder: React.FC<IDeleteFolderProps> = ({ folder, loading, onConfirm, onCancel }) => {
  const translate = getTranslateFunc('Folder: Confirm: Delete:');

  return (
    <IbConfirmModal
      footer={
        <>
          <IbButton key="delete-confirm" status="error" onClick={onConfirm}>
            {translate('Confirm')}
          </IbButton>
          <IbButton key="delete-cancel" type="secondary" onClick={onCancel}>
            {translate('Cancel')}
          </IbButton>
        </>
      }
      loading={loading}
      title={translate('Title')}
      visible={!!folder}
      onCancel={onCancel}
    >
      <IbTypography.Paragraph type="secondary">
        {isEmptyFolder(folder) ? translate('Content: Empty') : translate('Content: Items')}
      </IbTypography.Paragraph>
    </IbConfirmModal>
  );
};

export default DeleteFolder;
